@use "../../../../styles/icon-sizes";

:host {
  display: block;
  box-sizing: border-box;
  position: relative;

  ::slotted(fieldset) {
    box-sizing: border-box;
    padding: var(--spacing-xxs) 0 0 0;
    margin: 0;
    border: none;
    display: block;
  }

  .validation-icon {
    position: absolute;
    right: 0;
    margin-top: calc(2 * var(--spacing-xxs));
    margin-right: var(--spacing-xxs);
    height: icon-sizes.$icon-size-sm;
    width: icon-sizes.$icon-size-sm;

    &[name="system-error"] {
      --system-color: var(--color-error-base);
    }

    &[name="system-success"] {
      --system-color: var(--color-success-base);
    }
  }
}

:host(.valid) {
  ::slotted(fieldset) {
    outline: 2px solid var(--color-success-base);
    padding-left: var(--spacing-xxs);
    padding-bottom: var(--spacing-xxs);
    padding-right: calc(var(--spacing-xxs) + #{icon-sizes.$icon-size-sm} + var(--spacing-xxs));
    margin: var(--spacing-xxs) 0 0;
  }
}

:host(.invalid) {
  ::slotted(fieldset) {
    outline: 2px solid var(--color-error-base);
    padding-left: var(--spacing-xxs);
    padding-bottom: var(--spacing-xxs);
    padding-right: calc(var(--spacing-xxs) + #{icon-sizes.$icon-size-sm} + var(--spacing-xxs));
    margin: var(--spacing-xxs) 0 0;
  }
}
